/**
 * CookiePolicyPage - Politique de cookies
 */

import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CookiePolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <button
            onClick={() => navigate('/shop')}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-gray-600" />
          </button>
          <h1 className="text-xl font-bold text-gray-800">Politique de cookies</h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <p className="text-sm text-gray-600 mb-8">Derniere mise a jour : 27 mars 2026</p>

        {/* Introduction */}
        <section className="mb-10">
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p>
              La presente politique explique comment notre site <strong>foliesboutik.be</strong> utilise les
              cookies et technologies similaires (localStorage, sessionStorage) pour assurer son bon fonctionnement.
            </p>
          </div>
        </section>

        {/* Qu'est-ce qu'un cookie ? */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Qu'est-ce qu'un cookie ?</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p>
              Un cookie est un petit fichier texte depose sur votre appareil (ordinateur, tablette, smartphone)
              lorsque vous visitez un site web. Il permet au site de se souvenir de certaines informations
              pour ameliorer votre experience de navigation.
            </p>
          </div>
        </section>

        {/* Cookies utilises */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Cookies et stockage local utilises</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p>
              Notre site utilise <strong>uniquement des cookies et un stockage local strictement necessaires</strong> au
              fonctionnement du service. Nous n'utilisons aucun cookie publicitaire, de tracking
              ou d'analyse comportementale.
            </p>
          </div>

          <div className="mt-4 overflow-x-auto">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="bg-green-50">
                  <th className="border border-gray-300 px-4 py-3 text-left font-bold text-gray-900">Nom</th>
                  <th className="border border-gray-300 px-4 py-3 text-left font-bold text-gray-900">Type</th>
                  <th className="border border-gray-300 px-4 py-3 text-left font-bold text-gray-900">Finalite</th>
                  <th className="border border-gray-300 px-4 py-3 text-left font-bold text-gray-900">Duree</th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                <tr>
                  <td className="border border-gray-300 px-4 py-3 font-mono text-xs">CUSTOMER_TOKEN</td>
                  <td className="border border-gray-300 px-4 py-3">localStorage</td>
                  <td className="border border-gray-300 px-4 py-3">Session d'authentification client</td>
                  <td className="border border-gray-300 px-4 py-3">Jusqu'a deconnexion</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 px-4 py-3 font-mono text-xs">CUSTOMER_TENANT</td>
                  <td className="border border-gray-300 px-4 py-3">localStorage</td>
                  <td className="border border-gray-300 px-4 py-3">Boutique selectionnee</td>
                  <td className="border border-gray-300 px-4 py-3">Jusqu'a deconnexion</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-3 font-mono text-xs">ecom_cart_*</td>
                  <td className="border border-gray-300 px-4 py-3">localStorage</td>
                  <td className="border border-gray-300 px-4 py-3">Contenu du panier</td>
                  <td className="border border-gray-300 px-4 py-3">Jusqu'a suppression manuelle</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 px-4 py-3 font-mono text-xs">cookie_consent</td>
                  <td className="border border-gray-300 px-4 py-3">localStorage</td>
                  <td className="border border-gray-300 px-4 py-3">Memorise l'acceptation de la banniere cookies</td>
                  <td className="border border-gray-300 px-4 py-3">1 an</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-3 font-mono text-xs">pwa_install_*</td>
                  <td className="border border-gray-300 px-4 py-3">localStorage</td>
                  <td className="border border-gray-300 px-4 py-3">Etat de l'invitation d'installation PWA</td>
                  <td className="border border-gray-300 px-4 py-3">30 jours</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 px-4 py-3 font-mono text-xs">shop_favoris_invite</td>
                  <td className="border border-gray-300 px-4 py-3">localStorage</td>
                  <td className="border border-gray-300 px-4 py-3">Produits favoris choisis sans compte (rattaches au compte a la connexion)</td>
                  <td className="border border-gray-300 px-4 py-3">Jusqu'a connexion ou suppression manuelle</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Cookies tiers */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Cookies tiers</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p>
              <strong>Firebase Cloud Messaging</strong> : si vous autorisez les notifications push, un token
              d'identification de votre appareil est genere par Firebase (Google). Ce token ne contient aucune
              information personnelle identifiable et sert uniquement a acheminer les notifications.
            </p>
            <p>
              <strong>Stripe</strong> : lors du paiement par carte bancaire, Stripe peut deposer des cookies
              strictement necessaires au traitement securise du paiement. Ces cookies sont regis par la politique
              de confidentialite de Stripe.
            </p>
          </div>
        </section>

        {/* Gestion des cookies */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Comment gerer les cookies ?</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p>
              Vous pouvez a tout moment supprimer les donnees de stockage local de notre site via les parametres
              de votre navigateur :
            </p>
            <ul>
              <li><strong>Safari</strong> : Preferences → Confidentialite → Gerer les donnees de sites web</li>
              <li><strong>Chrome</strong> : Parametres → Confidentialite et securite → Cookies et autres donnees de sites</li>
              <li><strong>Firefox</strong> : Parametres → Vie privee et securite → Cookies et donnees de sites</li>
            </ul>
            <p>
              <strong>Attention :</strong> la suppression des cookies necessaires entrainera la deconnexion de votre
              compte et la perte du contenu de votre panier.
            </p>
          </div>
        </section>

        {/* Bouton retour */}
        <div className="text-center mt-12">
          <button
            onClick={() => navigate('/shop')}
            className="px-8 py-3 bg-green-600 text-white font-semibold rounded-lg transition-opacity hover:opacity-90"
          >
            Retour a la boutique
          </button>
        </div>
      </main>

    </div>
  );
}
